import { render, staticRenderFns } from "./DataCount.vue?vue&type=template&id=08a7b290&scoped=true"
import script from "./DataCount.vue?vue&type=script&lang=js"
export * from "./DataCount.vue?vue&type=script&lang=js"
import style0 from "./DataCount.vue?vue&type=style&index=0&id=08a7b290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7b290",
  null
  
)

export default component.exports